import { useEffect, useRef } from 'react';

interface UseRandomIntervalOptions {
  minMs: number;
  maxMs: number;
  enabled?: boolean;
}

export function useRandomInterval(
  callback: () => void,
  { minMs, maxMs, enabled = true }: UseRandomIntervalOptions
) {
  const savedCallback = useRef(callback);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    let timeoutId: ReturnType<typeof setTimeout>;

    const schedule = () => {
      const delay = Math.floor(minMs + Math.random() * Math.max(0, maxMs - minMs));

      timeoutId = setTimeout(() => {
        savedCallback.current();
        schedule();
      }, delay);
    };

    schedule();

    return () => clearTimeout(timeoutId);
  }, [enabled, minMs, maxMs]);
}
